// surveyTranslations.jsx
import React from 'react';
import SentimentSatisfiedIcon    from '@mui/icons-material/SentimentSatisfied';
import SentimentSatisfiedAltIcon from '@mui/icons-material/SentimentSatisfiedAlt';
import PetsIcon                  from '@mui/icons-material/Pets';
import StarIcon                  from '@mui/icons-material/Star';
import FaceIcon                  from '@mui/icons-material/Face';
import TuneIcon                  from '@mui/icons-material/Tune';
import TextFieldsIcon            from '@mui/icons-material/TextFields';
import RadioButtonCheckedIcon    from '@mui/icons-material/RadioButtonChecked';
import NumbersIcon               from '@mui/icons-material/Numbers';
import ThumbsUpDownIcon          from '@mui/icons-material/ThumbsUpDown'; // ← nuevo

export const translations = {
  es: {
    initialQuestionText: '',
    copyTimeout: 2000,
    initialErrors: { title: '', description: '', questions: {} },
    questionTypes: [
      { value: 'emojis',        label: 'Emojis amarillos',   icon: <SentimentSatisfiedIcon />,    description: 'Caritas amarillas' },
      { value: 'emojis2',       label: 'Emojis con colores', icon: <SentimentSatisfiedAltIcon />, description: 'Emojis coloridos' },
      { value: 'emojisCat',     label: 'Emojis de gatitos',  icon: <PetsIcon />,                  description: 'Emojis de gatitos' },
      { value: 'emojispeople',  label: 'Emojis de personas', icon: <FaceIcon />,                  description: 'Emojis de caras' },
      { value: 'emojisnumbers', label: 'Números 1 al 5',     icon: <NumbersIcon />,               description: 'Escala numérica 1-5' },
      { value: 'emojislike',    label: 'Like / No me gusta', icon: <ThumbsUpDownIcon />,          description: 'Like, dislike y más' }, // ← nuevo
      { value: 'rating',        label: 'Estrellas',          icon: <StarIcon />,                  description: 'Estrellas (1-5)' },
      { value: 'slider',        label: 'Slider',             icon: <TuneIcon />,                  description: 'Control deslizante' },
      { value: 'text',          label: 'Texto',              icon: <TextFieldsIcon />,             description: 'Para respuestas abiertas' },
      { value: 'radio',         label: 'Opción múltiple',    icon: <RadioButtonCheckedIcon />,    description: 'Seleccionar opciones' },
    ],
    defaultSliderConfig:   { min: 1, max: 5 },
    defaultEmojiConfig:    { show: true, left: 'Pésimo',      right: 'Excelente' },
    defaultEmojiLikeConfig:{ show: true, left: 'No me gusta', right: 'Me gusta'  }, // ← nuevo

    // ── Options / Radio ──────────────────────────────────────────────
    optionPlaceholder:      'Opción {index}',
    newOptionPlaceholder:   'Nueva opción',
    addButton:              'Añadir',
    removeOptionAriaLabel:  'Eliminar opción',
    radioOptionsTitle:      'Opciones de selección',
    radioOptionsEmpty:      'Agrega opciones para que el usuario pueda seleccionar',
    radioOptionsMinTwo:     'Se requieren al menos 2 opciones',
    radioOptionsAllFilled:  'Las opciones no pueden estar vacías',

    // ── Slider ───────────────────────────────────────────────────────
    sliderConfigTitle: 'Configuración del Slider',
    sliderRangeLabel:  'Rango del slider',
    sliderRange5:      '1 a 5',
    sliderRange10:     '1 a 10',

    // ── Emoji config ─────────────────────────────────────────────────
    emojiConfigTitle:     'Configuración de Texto Descriptivo',
    showTextLabel:        'Mostrar texto descriptivo',
    showTextTooltip:      'Muestra texto explicativo debajo de los emojis',
    leftTextLabel:        'Texto izquierdo',
    leftTextPlaceholder:  'Pésimo',
    leftTextHelper:       'Se muestra debajo del primer emoji',
    rightTextLabel:       'Texto derecho',
    rightTextPlaceholder: 'Excelente',
    rightTextHelper:      'Se muestra debajo del último emoji',

    // ── Question form ────────────────────────────────────────────────
    questionTextLabel:      'Texto de la pregunta',
    questionTypeLabel:      'Tipo de pregunta',
    requiredLabel:          'Obligatoria',
    requiredTooltip:        'Pregunta obligatoria',
    moveUpTooltip:          'Mover arriba',
    moveDownTooltip:        'Mover abajo',
    firstQuestion:          'Primera pregunta',
    lastQuestion:           'Última pregunta',
    deleteTooltip:          'Eliminar',
    minOneQuestion:         'Mínimo una pregunta',
    questionsTitle:         'Preguntas',
    addQuestionModalTitle:  'Agregar Nueva Pregunta',
    cancelButton:           'Cancelar',
    addButtonModal:         'Agregar',
    questionTextErrorShort: 'La pregunta debe tener al menos 5 caracteres.',
    questionTextErrorLong:  'La pregunta no puede tener más de 200 caracteres.',

    // ── Survey Settings Modal ────────────────────────────────────────
    settingsModalTitle:      'Configuración de la encuesta',
    settingsButtonTooltip:   'Configuración de la encuesta',
    settingsButtonText:      'Configuración',
    settingsButtonAriaLabel: 'Abrir configuración',
    // ── Pestañas del modal de configuración ──────────────────────────
    settingsTabDesign:       'Diseño',
    settingsTabEvaluate:     'Evaluación',
    styleLabel:              'Estilo de fondo',
    acceptButton:            'Aceptar',
    showLogoLabel:           'Mostrar Logo',
    requiresSubscription:    'Requiere suscripción activa',
    logoVisible:             'Visible en el formulario',
    logoHidden:              'Oculto',
    enableCommentsLabel:     'Habilitar Comentarios',
    commentsVisible:         'Campo visible al final del formulario',
    commentsDisabled:        'Deshabilitado',

    // ── Mostrar resultado final ───────────────────────────────────────
    showResultLabel:         'Mostrar Resultado Final',
    resultVisible:           'El resultado se mostrará al usuario al finalizar',
    resultHidden:            'Deshabilitado',

    // ── General info card chips ──────────────────────────────────────
    surveyStatus: 'Estado de la Encuesta',
    active:       'Activa',
    inactive:     'Inactiva',
    chipLogo:     'Logo',
    chipComments: 'Comentarios',
    chipResult:   'Resultado visible',
    chipUnsaved:  'Sin guardar',
    chipSaved:    'Guardado',

    // ── Comment preview section ──────────────────────────────────────
    commentPreviewLabel:  'Vista previa — Sección de comentarios',
    commentAtEnd:         'Al final del formulario',
    commentPlaceholder:   'Escribe aquí tus comentarios o sugerencias…',
    commentFieldLabel:    'Comentarios (opcional)',
    commentHelperText:    'Los encuestados verán este campo al final del formulario antes de enviar sus respuestas.',

    // ── Question progress bar ────────────────────────────────────────
    questionsProgressLabel: 'Preguntas',
    questionsLimitReached:  'Límite de preguntas alcanzado. Actualiza tu plan para agregar más.',

    // ── FABs ─────────────────────────────────────────────────────────
    fabAddLabel:      'Agregar',
    fabPreviewLabel:  'Vista previa',
    fabSaveLabel:     'Guardar',
    fabSaveTooltip:   'Guardar encuesta',
    fabSaveAriaLabel: 'guardar encuesta',

    // ── Survey titles / navigation ───────────────────────────────────
    newSurveyTitle:         'Nueva Encuesta',
    editSurveyTitle:        'Editar Encuesta',
    generalInfoTitle:       'Información General de la Encuesta',
    surveyTitleLabel:       'Título de la encuesta',
    surveyDescriptionLabel: 'Descripción de la encuesta',
    shareLinkTitle:         'Enlace para Compartir',
    copyTooltip:            'Copiar URL',
    copiedTooltip:          '¡Copiado!',
    viewSurveyButton:       'Ver Encuesta',
    addQuestionTooltip:     'Agregar Pregunta',
    previewTooltip:         'Vista Previa',

    // ── Save / status ────────────────────────────────────────────────
    saving:               'Guardando encuesta...',
    updating:             'Actualizando encuesta...',
    ctrlSHint:            'Ctrl+S para guardar',
    savedSnackbarEdit:    '✅ Encuesta actualizada',
    savedSnackbarCreate:  '✅ Encuesta guardada',
    saveErrorSnackbar:    'Error al guardar. Intenta de nuevo.',
    successTitleUpdated:  'Encuesta actualizada con éxito',
    successTitleCreated:  'Encuesta creada con éxito',
    successMessageUpdated: 'La encuesta "{title}" ha sido actualizada correctamente. ¿Qué deseas hacer ahora?',
    successMessageCreated: 'La encuesta "{title}" ha sido guardada correctamente. ¿Qué deseas hacer ahora?',
    newSurveyButton:      'Nueva encuesta',
    closeButton:          'Cerrar',
    previewTitle:         'Vista Previa de la Encuesta',
    saveButtonUpdating:   'Actualizando...',
    saveButtonSaving:     'Guardando...',
    saveButtonNoChanges:  'Sin Cambios por Guardar',
    saveButtonUpdate:     'Actualizar Encuesta',
    saveButtonSave:       'Guardar Encuesta',
    saveButtonSaved:      'Encuesta Guardada',

    // ── Validation ───────────────────────────────────────────────────
    titleRequired:        'El título es obligatorio',
    descriptionRequired:  'La descripción es obligatoria',
    questionTextRequired: 'El texto de la pregunta es obligatorio',

    // ── Limits / upgrade ────────────────────────────────────────────
    maxQuestionsReachedTitle: 'Límite de preguntas alcanzado',
    maxQuestionsReachedMsg:   'Tu plan permite un máximo de {max} preguntas. Actualmente tienes {count}.',
    addDisabledTooltip:       'No puedes agregar más preguntas (límite alcanzado).',
    maxSurveysReachedTitle:   'Límite de encuestas alcanzado',
    maxSurveysReachedMsg:     'Tu plan permite un máximo de {max} encuestas. Actualmente tienes {count}.',
    upgradePlan:              'Actualizar Plan',
    currentTotal:             'Tienes {count} encuestas creadas.',
    limitReached:             'Has alcanzado el límite de {max} encuestas en tu plan actual. Actualiza tu plan para crear más.',
    upgradeButton:            'Actualizar Plan',
    loading:                  'Cargando...',

    // ── Question image upload ────────────────────────────────────────
    imageUploadTitle:       'Imagen de la pregunta',
    imageUploadHide:        'ocultar',
    imageUploadShow:        'agregar',
    imageWithLabel:         'con imagen',
    imageNone:              'Sin imagen',
    imageFormat:            'JPG / PNG · máx. 300 px',
    imageChange:            'Cambiar imagen',
    imageAdd:               'Agregar imagen',
    imageRemove:            'Eliminar imagen',
    imageLockedBadge:       'Solo con suscripción',
    imageLockedDescription: 'Añade imágenes ilustrativas a tus preguntas para hacerlas más claras y atractivas.',
    imageLockedCta:         'Mejora tu plan para desbloquear esta función',
    imageUploading:         'Subiendo...',

    // ── Reglas de interpretación del resultado final ──────────────────
    resultCustomizeTitle:       'Reglas de interpretación del resultado',
    resultLabelsHelper:         'Define qué significa cada resultado según la suma global de respuestas. Puedes usar igualdad, menor/mayor que, o un rango ("Entre"). Ejemplo: Entre 1 y 2 → "Muy mal".',
    resultLevelLabel:           'Resultado',
    resultOperatorLabel:        'Operador',
    resultOperatorBetween:      'Entre',
    resultValueLabel:           'Cantidad',
    resultValueFromLabel:       'Desde',
    resultValueToLabel:         'Hasta',
    resultInterpretationLabel:  'Interpretación',
    resultDetailsLabel:         'Detalles',
    resultDetailsPlaceholder:   'Información adicional sobre este resultado (opcional)',
    addRuleButton:              'Agregar resultado',
    removeRuleAriaLabel:        'Eliminar resultado',
    defaultResultLabels:        ['Muy mal', 'Mal', 'Bien', 'Más o menos', 'Excelente'],
    resultRulesCountSuffix:     'resultados configurados',
    collapseAriaLabel:          'Contraer',
    expandAriaLabel:            'Expandir',
  },

  en: {
    initialQuestionText: '',
    copyTimeout: 2000,
    initialErrors: { title: '', description: '', questions: {} },
    questionTypes: [
      { value: 'emojis',        label: 'Yellow Emojis',    icon: <SentimentSatisfiedIcon />,    description: 'Yellow faces' },
      { value: 'emojis2',       label: 'Colored Emojis',   icon: <SentimentSatisfiedAltIcon />, description: 'Colorful emojis' },
      { value: 'emojisCat',     label: 'Cat Emojis',       icon: <PetsIcon />,                  description: 'Cat emojis' },
      { value: 'emojispeople',  label: 'People Emojis',    icon: <FaceIcon />,                  description: 'Face emojis' },
      { value: 'emojisnumbers', label: 'Numbers 1 to 5',   icon: <NumbersIcon />,               description: 'Numeric scale 1-5' },
      { value: 'emojislike',    label: 'Like / Dislike',   icon: <ThumbsUpDownIcon />,          description: 'Like, dislike & more' }, // ← nuevo
      { value: 'rating',        label: 'Stars',            icon: <StarIcon />,                  description: 'Stars (1-5)' },
      { value: 'slider',        label: 'Slider',           icon: <TuneIcon />,                  description: 'Slider control' },
      { value: 'text',          label: 'Text',             icon: <TextFieldsIcon />,             description: 'For open responses' },
      { value: 'radio',         label: 'Multiple Choice',  icon: <RadioButtonCheckedIcon />,    description: 'Select options' },
    ],
    defaultSliderConfig:   { min: 1, max: 5 },
    defaultEmojiConfig:    { show: true, left: 'Poor',    right: 'Excellent' },
    defaultEmojiLikeConfig:{ show: true, left: 'Dislike', right: 'Like'      }, // ← nuevo

    // ── Options / Radio ──────────────────────────────────────────────
    optionPlaceholder:      'Option {index}',
    newOptionPlaceholder:   'New option',
    addButton:              'Add',
    removeOptionAriaLabel:  'Remove option',
    radioOptionsTitle:      'Selection Options',
    radioOptionsEmpty:      'Add options for the user to select',
    radioOptionsMinTwo:     'At least 2 options are required',
    radioOptionsAllFilled:  'Options cannot be empty',

    // ── Slider ───────────────────────────────────────────────────────
    sliderConfigTitle: 'Slider Configuration',
    sliderRangeLabel:  'Slider range',
    sliderRange5:      '1 to 5',
    sliderRange10:     '1 to 10',

    // ── Emoji config ─────────────────────────────────────────────────
    emojiConfigTitle:     'Descriptive Text Configuration',
    showTextLabel:        'Show descriptive text',
    showTextTooltip:      'Shows explanatory text below the emojis',
    leftTextLabel:        'Left text',
    leftTextPlaceholder:  'Poor',
    leftTextHelper:       'Displayed below the first emoji',
    rightTextLabel:       'Right text',
    rightTextPlaceholder: 'Excellent',
    rightTextHelper:      'Displayed below the last emoji',

    // ── Question form ────────────────────────────────────────────────
    questionTextLabel:      'Question text',
    questionTypeLabel:      'Question type',
    requiredLabel:          'Required',
    requiredTooltip:        'Required question',
    moveUpTooltip:          'Move up',
    moveDownTooltip:        'Move down',
    firstQuestion:          'First question',
    lastQuestion:           'Last question',
    deleteTooltip:          'Delete',
    minOneQuestion:         'Minimum one question',
    questionsTitle:         'Questions',
    addQuestionModalTitle:  'Add New Question',
    cancelButton:           'Cancel',
    addButtonModal:         'Add',
    questionTextErrorShort: 'The question must have at least 5 characters.',
    questionTextErrorLong:  'The question cannot have more than 200 characters.',

    // ── Survey Settings Modal ────────────────────────────────────────
    settingsModalTitle:      'Survey Settings',
    settingsButtonTooltip:   'Survey settings',
    settingsButtonText:      'Settings',
    settingsButtonAriaLabel: 'Open settings',
    // ── Settings modal tabs ──────────────────────────────────────────
    settingsTabDesign:       'Design',
    settingsTabEvaluate:     'Evaluation',
    styleLabel:              'Background style',
    acceptButton:            'Accept',
    showLogoLabel:           'Show Logo',
    requiresSubscription:    'Requires active subscription',
    logoVisible:             'Visible in the form',
    logoHidden:              'Hidden',
    enableCommentsLabel:     'Enable Comments',
    commentsVisible:         'Field visible at the end of the form',
    commentsDisabled:        'Disabled',

    // ── Show final result ─────────────────────────────────────────────
    showResultLabel:         'Show Final Result',
    resultVisible:           'Result will be shown to the user at the end',
    resultHidden:            'Disabled',

    // ── General info card chips ──────────────────────────────────────
    surveyStatus: 'Survey Status',
    active:       'Active',
    inactive:     'Inactive',
    chipLogo:     'Logo',
    chipComments: 'Comments',
    chipResult:   'Result visible',
    chipUnsaved:  'Unsaved',
    chipSaved:    'Saved',

    // ── Comment preview section ──────────────────────────────────────
    commentPreviewLabel: 'Preview — Comments Section',
    commentAtEnd:        'At the end of the form',
    commentPlaceholder:  'Write your comments or suggestions here…',
    commentFieldLabel:   'Comments (optional)',
    commentHelperText:   'Respondents will see this field at the end of the form before submitting their answers.',

    // ── Question progress bar ────────────────────────────────────────
    questionsProgressLabel: 'Questions',
    questionsLimitReached:  'Question limit reached. Upgrade your plan to add more.',

    // ── FABs ─────────────────────────────────────────────────────────
    fabAddLabel:      'Add',
    fabPreviewLabel:  'Preview',
    fabSaveLabel:     'Save',
    fabSaveTooltip:   'Save survey',
    fabSaveAriaLabel: 'save survey',

    // ── Survey titles / navigation ───────────────────────────────────
    newSurveyTitle:         'New Survey',
    editSurveyTitle:        'Edit Survey',
    generalInfoTitle:       'General Survey Information',
    surveyTitleLabel:       'Survey title',
    surveyDescriptionLabel: 'Survey description',
    shareLinkTitle:         'Share Link',
    copyTooltip:            'Copy URL',
    copiedTooltip:          'Copied!',
    viewSurveyButton:       'View Survey',
    addQuestionTooltip:     'Add Question',
    previewTooltip:         'Preview',

    // ── Save / status ────────────────────────────────────────────────
    saving:               'Saving survey...',
    updating:             'Updating survey...',
    ctrlSHint:            'Ctrl+S to save',
    savedSnackbarEdit:    '✅ Survey updated',
    savedSnackbarCreate:  '✅ Survey saved',
    saveErrorSnackbar:    'Error saving. Please try again.',
    successTitleUpdated:  'Survey updated successfully',
    successTitleCreated:  'Survey created successfully',
    successMessageUpdated: 'The survey "{title}" has been updated successfully. What do you want to do now?',
    successMessageCreated: 'The survey "{title}" has been saved successfully. What do you want to do now?',
    newSurveyButton:      'New survey',
    closeButton:          'Close',
    previewTitle:         'Survey Preview',
    saveButtonUpdating:   'Updating...',
    saveButtonSaving:     'Saving...',
    saveButtonNoChanges:  'No Changes to Save',
    saveButtonUpdate:     'Update Survey',
    saveButtonSave:       'Save Survey',
    saveButtonSaved:      'Survey Saved',

    // ── Validation ───────────────────────────────────────────────────
    titleRequired:        'Title is required',
    descriptionRequired:  'Description is required',
    questionTextRequired: 'Question text is required',

    // ── Limits / upgrade ────────────────────────────────────────────
    maxQuestionsReachedTitle: 'Question limit reached',
    maxQuestionsReachedMsg:   'Your plan allows a maximum of {max} questions. You currently have {count}.',
    addDisabledTooltip:       'You cannot add more questions (limit reached).',
    maxSurveysReachedTitle:   'Survey limit reached',
    maxSurveysReachedMsg:     'Your plan allows a maximum of {max} surveys. You currently have {count}.',
    upgradePlan:              'Upgrade Plan',
    currentTotal:             'You have created {count} surveys.',
    limitReached:             'You have reached the limit of {max} surveys in your current plan. Upgrade your plan to create more.',
    upgradeButton:            'Upgrade Plan',
    loading:                  'Loading...',

    // ── Question image upload ────────────────────────────────────────
    imageUploadTitle:       'Question Image',
    imageUploadHide:        'hide',
    imageUploadShow:        'add',
    imageWithLabel:         'with image',
    imageNone:              'No image',
    imageFormat:            'JPG / PNG · max. 300 px',
    imageChange:            'Change image',
    imageAdd:               'Add image',
    imageRemove:            'Remove image',
    imageLockedBadge:       'Subscription only',
    imageLockedDescription: 'Add illustrative images to your questions to make them clearer and more engaging.',
    imageLockedCta:         'Upgrade your plan to unlock this feature',
    imageUploading:         'Uploading...',

    // ── Result interpretation rules ────────────────────────────────────
    resultCustomizeTitle:       'Result interpretation rules',
    resultLabelsHelper:         'Define what each result means based on the total sum of answers. You can use equals, less/greater than, or a range ("Between"). Example: Between 1 and 2 → "Very poor".',
    resultLevelLabel:           'Result',
    resultOperatorLabel:        'Operator',
    resultOperatorBetween:      'Between',
    resultValueLabel:           'Amount',
    resultValueFromLabel:       'From',
    resultValueToLabel:         'To',
    resultInterpretationLabel:  'Interpretation',
    resultDetailsLabel:         'Details',
    resultDetailsPlaceholder:   'Additional information about this result (optional)',
    addRuleButton:              'Add result',
    removeRuleAriaLabel:        'Remove result',
    defaultResultLabels:        ['Very poor', 'Poor', 'Good', 'Fair', 'Excellent'],
    resultRulesCountSuffix:     'results configured',
    collapseAriaLabel:          'Collapse',
    expandAriaLabel:            'Expand',
  },
};